define('views/parts/menu/menu-context',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // views
    'src/views/click-outside-view',
    'views/parts/menu/menu',
    // templates
    'text!templates/parts/menu/context-menu.html',
    'text!templates/parts/menu/context-menu-item.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VClickOutside,
    VMenu,
    // templates
    TContextMenu,
    TContextMenuItem
) {

    /**
     * Generic context menu view.
     *
     * Uses the generic menu view, but adds a custom template and a
     * layer of events, handling focus and blur.
     *
     * 	   // build collection for item (best in initialize function of your view)
     *     this.actionCollection = new Backbone.Collection([
     *         { title: 'New message', icon: false, callback: this.onNewMessage },
     *         { title: 'Search', icon: 'sl-icon-magnifier', callback: this.onSearchTrigger },
     *         { title: 'Delete all selected message', icon: 'sl-icon-trash', callback: this.onDeleteMessage },
     *     ]);
     *     // listen for the click callback
     *     this.listenTo(this.actionCollection, "item:click", this.onActionClicked);
     *     // Create a new menu view instance
     *     this.view.contextMenu = new VMenuContext({
     *         template: '{{^empty}}<span class="{{icon}}"></span><p>{{title}}</p>{{/empty}}',
     *         collection: this.actionCollection
     *     });
     *
     * @param  {template} items HTML template
     * @param  {Backbone.Collection} collection, the data to use inside the items template.
     */
    var VMenuContext = VClickOutside.extend({
        template: TContextMenu,

        events: {
            "click": "onClick",
            "click:outside": "close",
        },

        regions: {
            menu: ".menu-options-list",
        },

        initialize: function(opt) {
            this.options = _.extend({
                arrow: "top",
                radio: false,
                templateItem: TContextMenuItem
            }, opt);

            this.view = {
                menu: new VMenu(this.options)
            };

            this.listenTo(this.collection, 'item:click', this.close);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));
            this.generateZones()
                .assign(this.view.menu, this.zone.$menu);
            return this;
        },

        toggle: function(val) {
            this.$el.toggleClass('open', val).focus();
            return this;
        },

        close: function() {
            this.$el.removeClass('open');
            return this;
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            e.stopPropagation();
        },

    });

    return VMenuContext;

});

